import React from 'react'
import {User} from '../../../../../../../interfaces/user'

interface Props {
  user: User
}

export const UserStatusCell = ({user}: Props) => {
  const getStatusClassName = () => {
    switch (user.status) {
      case 'active':
        return 'text-success'
      case 'deleted':
        return 'text-danger'
      case 'blocked':
        return 'text-danger'
      default:
        return ''
    }
  }

  return <span className={getStatusClassName()}>{user.formattedStatus}</span>
}
